import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import '../Property.css';

import ReviewPropertyForm from './reviewProperty/ReviewPropertyForm';

export default connect(store => ({
  showPage: store.authentication.showPage,
  initialValues: store.landlordProperties.property,
}))(
  class ReviewProperty extends Component {
    UNSAFE_componentWillMount() {
      window.onbeforeunload = function() {
        return false;
      };
    }

    componentWillUnmount() {
      window.onbeforeunload = function() {
        return undefined;
      };
    }

    previousPage = () => {
      browserHistory.push('/companies/properties');
    };

    render() {
      const { initialValues, goToPage } = this.props;

      return (
        <div>
          {this.props.showPage && (
            <div className="centers">
              <div className="row">
                {initialValues.editable === 'true' && (
                  <button
                    type="button"
                    className="link-button"
                    onClick={event => {
                      event.preventDefault();
                      goToPage(1);
                    }}
                    style={{
                      cursor: 'pointer',
                      margin: '10px auto 0px auto',
                      display: 'block',
                      textAlign: 'center',
                    }}
                  >
                    Edit Name
                  </button>
                )}
              </div>

              <ReviewPropertyForm goToPage={goToPage} previousPage={this.previousPage} />

              <div style={{ height: '100px' }} />
            </div>
          )}
        </div>
      );
    }
  }
);
